export var newrelic = {
    addPageAction: function (name, value) {
        var _a;
        if (typeof window !== 'undefined' &&
            typeof ((_a = window.newrelic) === null || _a === void 0 ? void 0 : _a.addPageAction) === 'function') {
            window.newrelic.addPageAction(name, value);
        }
    },
};
